// Copyright (c) 2017 Deere & Company

import * as fetchService from '../../../shared/services/fetch';
import {handleError} from '../../../shared/services/error-handlers';
import {seperateLeadAccountsByTerritory} from '../services/tcsm-territories-helper';
const basePath = '/api';

export const getTerritories = async racfId => {

    const endPoint = `${basePath}/users/${racfId}/dealer-hierarchy`;

    try {

        const response = await fetchService.fetch(endPoint);

        const territoryArray = await response.json();

        return seperateLeadAccountsByTerritory(territoryArray);

    } catch (response) {

        return handleError(response);

    }

};



// WEBPACK FOOTER //
// ./src/user/shared/repositories/territories.js